module.exports = __webpack_public_path__ + "img/img.6cd0040c.png";